import { render, staticRenderFns } from "./StudentsInCourse.vue?vue&type=template&id=19e30de2&scoped=true&"
import script from "./StudentsInCourse.vue?vue&type=script&lang=js&"
export * from "./StudentsInCourse.vue?vue&type=script&lang=js&"
import style0 from "./StudentsInCourse.vue?vue&type=style&index=0&id=19e30de2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e30de2",
  null
  
)

export default component.exports